import { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CursorGlow } from './components/CursorGlow'
import { ParticleStars } from './components/ParticleStars'
import { ScanLines } from './components/ScanLines'
import { Navbar } from './components/Navbar'
import { Hero } from './components/Hero'
import { HighlightStrip } from './components/HighlightStrip'
import { FeatureDeepDive } from './components/FeatureDeepDive'
import { Stats } from './components/Stats'
import { MarketData } from './components/MarketData'
import { AppShowcase } from './components/AppShowcase'
import { Guide } from './components/Guide'
import { FAQ } from './components/FAQ'
import { Footer } from './components/Footer'

gsap.registerPlugin(ScrollTrigger)

function App() {
  useEffect(() => {
    // Refresh ScrollTrigger after all content is loaded
    const timer = setTimeout(() => {
      ScrollTrigger.refresh()
    }, 100)

    return () => {
      clearTimeout(timer)
      ScrollTrigger.getAll().forEach(trigger => trigger.kill())
    }
  }, [])

  return (
    <div className="relative min-h-screen bg-[#0a0a0f]">
      {/* Background Effects */}
      <CursorGlow />
      <ParticleStars />
      <ScanLines />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <Hero />

        {/* Trust/Security Section */}
        <HighlightStrip />

        {/* Features Section */}
        <FeatureDeepDive />

        {/* Stats Section */}
        <Stats />

        {/* Market Data Section */}
        <MarketData />

        {/* App Showcase Section */}
        <AppShowcase />

        {/* Guide Section */}
        <Guide />

        {/* FAQ Section */}
        <FAQ />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
